import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ px, tokens }) => ({
  root: {
    padding: px(tokens.spacing[16]),
    backgroundColor: tokens.colors.bg.light.primary,
    borderRadius: tokens.radius.l,
    border: '1px solid',
    borderColor: tokens.colors.stroke.primary,
    minHeight: px(272),
    position: 'relative',
    color: tokens.colors.text.light.primary,
    fontSize: tokens.typography.variant.body2.fontSize,
    lineHeight: tokens.typography.variant.body2.lineHeight,
    width: '100%',
    '&:focus-visible': {
      outline: 'none',
      borderColor: tokens.colors.original.brand.primary,
    },
  },

  flatRoot: {
    padding: 0,
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 0,
    minHeight: 'auto',
  },

  commtensRoot: {
    minHeight: px(56),
  },
  disabled: {
    backgroundColor: tokens.colors.bg.greyscale.secondary,
    opacity: 0.5,
    pointerEvents: 'none',
    userSelect: 'none',
    cursor: 'auto',
  },
  placeholder: {
    position: 'absolute',
    left: px(16),
    top: px(16),
  },
  toolbarDisabled: {
    pointerEvents: 'none',
    userSelect: 'none',
    cursor: 'pointer',
    '& *': {
      pointerEvents: 'none!important' as 'none',
      cursor: 'pointer!important' as 'pointer',
    },
    '& *:hover, & *:active, & *:focus': {
      pointerEvents: 'none!important' as 'none',
      cursor: 'pointer!important' as 'pointer',
    },
  },

  error: {
    backgroundColor: tokens.colors.accent.bg.error,
    borderColor: tokens.colors.accent.stroke.error,
  },

  toolbarSticky: {
    paddingTop: '24px',
    position: 'sticky',
    top: '65px',
    backgroundColor: tokens.colors.bg.greyscale.primary,
    zIndex: 10,
    outline: '1px solid',
    outlineColor: tokens.colors.bg.greyscale.primary,
    marginBottom: '1px',
  },
}));
